import { Loader2 } from 'lucide-react'

export function LoadingContainer({ children }: { children?: React.ReactNode }) {
  return (
    <div className="h-16 w-full animate-pulse bg-background flex items-center justify-center">
      <div className="flex items-center gap-2">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <div className="">{children}</div>
      </div>
    </div>
  )
}
